import ApplicationController from './application_controller'
import SlimSelect from 'slim-select'
import 'slim-select/styles'

export default class extends ApplicationController {
  static targets = ['select']

  connect() {
    if (this.hasSelectTarget) {
      this.select = this.initializeSelect()
    }
  }

  initializeSelect() {
    return new SlimSelect({
      select: this.selectTarget,
      settings: {
        placeholderText: this.selectTarget.dataset.placeholder,
        searchText: 'Search...',
        searchPlaceholder: 'Type to search...',
        allowDeselect: true,
        showSearch: true,
        searchFilter: (option, search) => {
          return option.text.toLowerCase().includes(search.toLowerCase())
        }
      },
      events: {
        afterChange: (newVal) => {
          this.handleSelection(newVal)
        }
      }
    })
  }


  handleSelection(selectedValue) {
    if (selectedValue && selectedValue.length > 0) {
      console.log('Organization selected:', selectedValue)
    }
  }

  disconnect() {
    if (this.select) {
      this.select.destroy()
    }
  }
}
